export const parseMap = (map, tab, favorites) => {
    if(tab === "inactive")
        map = map;
    else if(tab === "favorites")
        map = map.filter(game => favorites.includes(game.id));
    else
        map = map.filter(game => game.type === tab);


    const games_vertical = map.filter(g => g.format !== "squad"),
          games_horizontal_row = map.filter(g => g.format === "squad");

    const games_horizontal = [];
    
    let game_key = 0;
    for(const i in games_horizontal_row) {
        if(games_horizontal[game_key] && games_horizontal[game_key].length === 2)
            game_key++;

        if(typeof games_horizontal[game_key] === 'undefined')
            games_horizontal[game_key] = [];
        
        games_horizontal[game_key].push(games_horizontal_row[i]);
    }

    const count = games_vertical.length + games_horizontal.length;

    return {
        vertical: games_vertical,
        horizontal: games_horizontal,
        count: count < 5 ? 5 : count
    }
}